import { Reducer } from 'redux';
import { FamilyDoctorState, FamilyDoctorActionTypes } from './type';

const initialState: FamilyDoctorState = {
  isBuyedServpack: '',
  tryOutOrContinuedFeePoup:true,
  servPack: {},
  isBindDoctor: false,
  isDoctorNormalService:'',
  favourCountdownTime:'',
  doctorList: [],
  rights: {},
  bindDoctorInfo: { tryOutOrContinuedFeePoup: true },
  bannerList: [],
  userServpackDomain: {},
};

const reducer: Reducer<FamilyDoctorState> = (state = initialState, action) => {
  switch (action.type) {
    case FamilyDoctorActionTypes.UPDATE_FAMILY_DOCTOR_INFO: {
      const { data } = action;
      return {
        ...state,
        ...data,
      };
    }
    /*case FamilyDoctorActionTypes.UPDATE_BIND_DOCTOR_INFO: {
      const { data } = action;
      console.log(action,"actionactionaction")
      let { bindDoctorInfo = {} } = state;
      return {
        ...state,
        bindDoctorInfo: {
          ...bindDoctorInfo,
          ...data,
        },
      };
    }*/

    default: {
      return state;
    }
  }
};

export { reducer as FamilyDoctorReducer };
